import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import Modal from 'patient-ping-remedy/packages/modal';
import Button from 'patient-ping-remedy/packages/button';
import Icon from 'patient-ping-remedy/packages/icon';
import {StandardSemiBoldTypography, StandardTypography} from 'patient-ping-remedy/packages/typography';

export const SectionLabel = styled(StandardSemiBoldTypography)`
  display: block;
`;

export const SectionDescription = styled(StandardTypography)`
  display: block;
  margin-top: ${sizes.xSmall};
`;

export const UnassignButton = styled(Button)`
  white-space: nowrap;
`;

export const AssignmentState = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizes.xSmall};
  white-space: nowrap;
`;

export const AssignmentStateIcon = styled(Icon)`
  color: ${colors.charcoal};
`;

export const ConfirmUnassignModal = styled(Modal)`
  display: flex;
  flex-direction: column;
  width: 60rem;
  border-radius: 8px;
  padding: ${sizes.large};
  gap: ${sizes.medium};

  & [class*='header-container'] {
    border-bottom: none;
    padding: 0;
  }

  & [class*='header-text'] {
    padding: 0;
  }

  & [class*='modal-content'] {
    max-height: none;
    overflow: visible;
    padding: 0;
  }

  & [class*='footer-container'] {
    margin: 0;
  }

  & [class*='close-button'] {
    padding-right: 0;
  }

  & [class*='close-button'] svg {
    color: ${colors.purple5} !important;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.medium};
`;

export const CancelButton = styled(Button)`
  color: ${colors.purple5} !important;
`;
